import { TIPO_REMESA } from "api/Types/TipoRemesa"

export const INITIAL_IBAN_QUERY_PARAMETERS = {
  maxResult: 20,
  skipCount: 0,
  sortingCriteria: { sort: "", property: "nombre" },
  params: "",
  nombre: "",
}

export const mapBankListToSelect = (bankList: $TSMigrationFixMe) => {
  return bankList?.map((bank: $TSMigrationFixMe) => {
    return {
      label: bank?.nombre || bank?.entidadBancariaNombre,
      value: bank?.entidadBancariaId || bank?.id,
    }
  })
}

export const handleTransformEditedArray = (
  accountList: $TSMigrationFixMe,
  editedShape: $TSMigrationFixMe,
  id: $TSMigrationFixMe,
  customDefault: $TSMigrationFixMe
) => {
  const editIbanList = accountList.map((entry: $TSMigrationFixMe) => {
    if (entry.id === id) {
      const edited = {
        ...entry,
        ...editedShape,
      }
      return edited
    }

    return (
      {
        ...entry,
        ...customDefault,
      } || entry
    )
  })
  return editIbanList
}

export const BIC_LENGTH_OPTIONS = {
  MIN: 8,
  MAX: 11,
}

export const TIPO_REMESA_CONST = [
  { name: "CORE", code: TIPO_REMESA.CORE },
  { name: "B2B", code: TIPO_REMESA.B2B },
]

export const checkBicLength = (value: $TSMigrationFixMe) =>
  [BIC_LENGTH_OPTIONS.MIN, BIC_LENGTH_OPTIONS.MAX].includes(value?.length)
